// @flow
export const SET_PAYMENT_DASHBOARD_STATUS = 'SET_PAYMENT_DASHBOARD_STATUS';
export const SET_PAYMENT_SELECTED_PAGE = 'SET_PAYMENT_SELECTED_PAGE';
export const SET_LEFT_MENU_STATUS = 'SET_LEFT_MENU_STATUS';
export const SET_PAYMENT_HOSTED_ROOM = 'SET_PAYMENT_HOSTED_ROOM';
export const SET_PAYMENT_INVITED_ROOM = 'SET_PAYMENT_INVITED_ROOM';
export const SET_PAYMENT_INVITATION_ROOM = 'SET_PAYMENT_INVITATION_ROOM';
export const SET_PAYMENT_CONTACT = 'SET_PAYMENT_CONTACT';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_WINDOW_REF = 'SET_WINDOW_REF';
export const SET_USER_SUBSCRIPTION = 'SET_USER_SUBSCRIPTION';
export const SET_TIMEZONES = 'SET_TIMEZONES';

export const SET_INVITION_NOTIFICATION_COUNT = "SET_INVITION_NOTIFICATION_COUNT";
export const SHOW_PAYMENT_DASHBOARD = "SHOW_PAYMENT_DASHBOARD"; 

export const SET_AVAILABLE_SUB_PACKAGE = "SET_AVAILABLE_SUB_PACKAGE"; 

export const SET_PAID_ROOM_HISTORY = "SET_PAID_ROOM_HISTORY";
export const SET_SUBSCRIPTION_PAYMENT_HISTORY = "SET_SUBSCRIPTION_PAYMENT_HISTORY";





